import React, { Component } from 'react';
import NavBar from '../navbar/NavBar';
import Footer from '../footer/Footer';
import { K12 } from './k12';
import {CC} from './cc';
import { RET } from './ret';
import { REU } from './reu';
import {SI} from './si';
import { REU_A_2019 } from './reu_2019';
import { REU_A_2021 } from './reu_2021';
import { REU_A_2022 } from './reu_2022';
import { R_SEM } from './rsem';
import { SG } from './sg';
import { NT2025 } from './nt2025';
import { REU_RET_2023 } from './reu_ret';
import RETAlumni from '../../assets/Image/RETAlumni.jpg';

class Programs extends Component {
    constructor(props) {
        super(props)
        let { state } = this.props.location;
        let title = null;
        if (this.props.match.params.program){
            title = this.props.match.params.program;
        }
        if (state) {
            title = state.title
        }
        this.state = {
            title: title == null ? 'k12-curriculum' : title,
            renderHtml: title == null ? K12 : this.handleChangeRenderHtml(title),
        }
    }

    handleChangeTab = (param) => {
        this.setState({
            title: param,
            renderHtml: this.handleChangeRenderHtml(param)
        });
    }

    handleChangeRenderHtml = (param) => {
        this.props.history.replace({ pathname: '/programs/' + param, state: { title: param } });
        switch (param) {
            case 'k12-curriculum':
                return K12;
            case 'college-curriculum':
                return CC;
            case 'ret':
                return RET;
            case 'reu':
                return REU;
            case 'summer-institute':
                return SI;
            case 'ret-a':
                return (
                    <div>
                        <p className="title"><b>RET 2019 Alumni</b></p>
                        <img className="img-fluid" src={RETAlumni} alt="Image" />
                        <p>
                            <span className="programs-span">
                                <b>Back: </b>Lesli Horowitz<br />
                                <b>Left to right: </b>Angela Tsang, Patricia Beller, Lilia Ornelas, Gabriela Mansfield, Kerson Perez
                            </span>
                            <br /><br />
                            During the RET 2019 program teacher students received a solid series of lessons covering the fundamentals of nanotechnology as well as life sciences-focused nanotechnology seminars.
                            <br /><br />
                            At the end of the program, each RET student produce a lesson plan that they brought to their respective colleges/schools for implementation. In dsgng so SDNI hopes that the respective nanotechnology lessons will plant the seed for a growing nanotechnology program at each respective institution.
                            <br /><br />
                            <b>The lessons developed by the 2019 RET can be found in the section:</b>
                            <br /><br />
                            <button onClick={() => this.handleChangeTab('k12-curriculum')} className="programs-button">K-12 Curriculum</button>
                            <br /><br />
                            <button onClick={() => this.handleChangeTab('college-curriculum')} className="programs-button">College Curriculum</button>
                            <br /><br /><br /><br /><br />
                        </p>
                    </div>
                );
            case 'reu-a-2019':
                return REU_A_2019;
            case 'reu-a-2021':
                return REU_A_2021;
            case 'reu-a-2022':
                return REU_A_2022;
            case 'reu-ret-2023':
                return REU_RET_2023;
            case 'nt2025':
                return NT2025;
            case 'r-sem':
                return R_SEM;
            case 'sg':
                return SG;
            default:
                return K12;
        }
    }

    render() {
        const { renderHtml, title } = this.state;
        return (
            <div>
                <NavBar path='/programs' handler={this.handleChangeTab}></NavBar>
                <div className="container1">
                    <div className="row">
                        <div className="col-sm-3 submenu-tabs sidebar">
                            <button onClick={() => this.handleChangeTab('k12-curriculum')} className={title === 'k12-curriculum' ? "button1" : "button"}><span>K-12 Curriculum</span></button>
                            <button onClick={() => this.handleChangeTab('college-curriculum')} className={title === 'college-curriculum' ? "button1" : "button"}><span>College Curriculum</span></button>
                            <button onClick={() => this.handleChangeTab('ret')} className={title === 'ret' ? "button1" : "button"}><span>RET</span></button>
                            <button onClick={() => this.handleChangeTab('reu')} className={title === 'reu' ? "button1" : "button"}><span>REU</span></button>
                            <button onClick={() => this.handleChangeTab('summer-institute')} className={title === 'summer-institute' ? "button1" : "button"}><span>Summer Institute</span></button>
                            <button onClick={() => this.handleChangeTab('ret-a')} className={title === 'ret-a' ? "button1" : "button"}><span>RET Alumni</span></button>
                            <button onClick={() => this.handleChangeTab('reu-a-2019')} className={title.startsWith('reu-a') ? "button1" : "button"}><span>REU Alumni</span></button>
                            {
                                title.startsWith('reu-a') ?
                                    (<div style={{ marginLeft: 20, marginTop: 0 }}>
                                        <ul style={{ listStyleType: 'none', color: "#48457a" }}>
                                            <li className="sub-menu" style={title === 'reu-a-2019' ? { fontWeight: 'bold' } : {}} onClick={() => this.handleChangeTab('reu-a-2019')}>
                                                2019 SDNI REU
                                            </li>
                                            <li className="sub-menu" style={title === 'reu-a-2021' ? { fontWeight: 'bold' } : {}} onClick={() => this.handleChangeTab('reu-a-2021')}>
                                                2021 SDNI REU
                                            </li>
                                            <li className="sub-menu" style={title === 'reu-a-2022' ? { fontWeight: 'bold' } : {}} onClick={() => this.handleChangeTab('reu-a-2022')}>
                                                2022 SDNI REU
                                            </li>
                                        </ul>
                                    </div>) : null
                            }
                            <button onClick={() => this.handleChangeTab('reu-ret-2023')} className={title.startsWith('reu-ret') ? "button1" : "button"}><span>REU-RET Alumni</span></button>
                            {
                                title.startsWith('reu-ret') ?
                                    (<div style={{ marginLeft: 20, marginTop: 0 }}>
                                        <ul style={{ listStyleType: 'none', color: "#48457a" }}>
                                            <li className="sub-menu" style={title === 'reu-ret-2023' ? { fontWeight: 'bold' } : {}} onClick={() => this.handleChangeTab('reu-ret-2023')}>
                                                2023 SDNI REU-RET
                                            </li>
                                        </ul>
                                    </div>) : null
                            }
                            <button onClick={() => this.handleChangeTab('nt2025')} className={this.state.title === 'nt2025' ? "button1" : "button"}><span>NanoTech 2025 Project</span></button>
                            {/* <button onClick={() => this.handleChangeTab('2dt')} className={this.state.title === '2dt' ? "button1" : "button"}><span>Free Half-Day Workshops</span></button> */}
                            <button onClick={() => this.handleChangeTab('r-sem')} className={this.state.title === 'r-sem' ? "button1" : "button"}><span>Remote SEM</span></button>
                            <button onClick={() => this.handleChangeTab('sg')} className={this.state.title === 'sg' ? "button1" : "button"}><span>Seed Grants</span></button>
                        </div>
                        <div className="col-sm-7 main-content">
                            {renderHtml}
                        </div>
                        <div className="col-sm-2">
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        )
    }
}

export default Programs
